/**
 * Copy text to clipboard with fallback for older browsers.
 */
export async function copyToClipboard(text: string): Promise<void> {
  // Try to use modern clipboard API first
  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard.write) {
    const item = new ClipboardItem({
      'text/plain': new Blob([text], { type: 'text/plain' })
    })
    await navigator.clipboard.write([item])
  } else {
    // Fallback to older clipboard API
    await navigator.clipboard.writeText(text)
  }
}

/**
 * Build a client portal URL with optional access token.
 */
export function buildPortalUrl(path: string, accessToken?: string | null): string {
  const baseUrl = `${window.location.origin}${path}`
  if (accessToken?.trim()) {
    return `${baseUrl}?access_token=${accessToken}`
  }
  return baseUrl
}
